import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const uploadNewBannerAction = createAsyncThunk(
    'upload-new-banner',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/support-server/api/upload-banner` , {...data})
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const uploadNewBannerSlice = createSlice({
    name: 'upload-new-banner',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(uploadNewBannerAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(uploadNewBannerAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(uploadNewBannerAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const uploadNewBannerReducer = uploadNewBannerSlice.reducer